import * as React from 'react';
import {History} from 'history';
import {Loading} from '../loading/loading';
import Loadable from "react-loadable";
import {TicketEvent} from '../../models/ticketEvent';
import {TicketEventEntry} from '../ticketEventEntry/ticketEventEntry';
import {Server} from '../../services/server';
import {lazyInject} from '../../services/container';
import {PageComponent, PageComponentProps} from '../pageComponent';
import topLogo from '../../assets/images/top_logo.svg';

interface EventListPageProps extends PageComponentProps
{
    history: History;
}

export class EventListPage extends PageComponent<EventListPageProps>
{
    @lazyInject(Server)
    private server: Server;
    
    private loadableComponent: any;

    constructor(props: EventListPageProps, context: any)
    {
        super(props, context);
        
        this.loadableComponent = Loadable({
            loader: () => this.server.getAll(TicketEvent, `ticket-events/upcoming`),
            loading: () => <Loading />,
            render: (events: TicketEvent[], props: { history: History }) => {
                const eventEntries = events.map(event => <TicketEventEntry key={event.id} event={event} {...props} />);
                
                return eventEntries.length ? eventEntries : <div className="no-events">
                    {this.translate.translate('noEvents')}
                </div>;
            }
        });
    }

    render(): React.ReactNode
    {
        const LoadableComponent = this.loadableComponent;

        console.log("top-logo", topLogo);
        
        return <div className="nav-page event-list-page">
            <img className="top-logo" src={topLogo} alt=""/>
            <div className="top-logo-sep" />
            <div className="page-title">
                {this.translate.translate('upcomingEvents')}
            </div>
            <LoadableComponent history={this.props.history} />
        </div>;
    }
}